export default {"src":"/_next/static/media/close.51d16493.svg","height":40,"width":40};